import React from 'react';
import './style.sass';

const Triangle = ({ isUp = true, bgColor }) => {
  return (
    <span
      className={isUp ? 'triangle' : 'triangle triangle_reverse'}
      style={{ borderBottomColor: bgColor ?? '#000' }}
    ></span>
  );
};

export default Triangle;
